import Vue from 'vue'
import Router from 'vue-router'
import fb from './firebase'

Vue.use(Router)

// mobile-not-supported is still here to be backward compatible with 3.7.0, can go once 3.7.0 is depricated

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "eventList" */ './views/EventList')
  },
  {
    path: '/debug',
    name: 'debug',
    component: () => import(/* webpackChunkName: "public" */ './views/Debug')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "loginScreen" */ './views/Login')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import(/* webpackChunkName: "logout" */ './views/Logout')
  },
  {
    path: '/end-session',
    name: 'end-session',
    component: () => import(/* webpackChunkName: "EndSession" */ './views/EndSession')
  },
  {
    path: '/team',
    name: 'team',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "memberManager" */ './views/MemberManagement')
  },
  {
    path: '/teamsettings',
    name: 'teamsettings',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "memberManager" */ './views/TeamManagement')
  },
  {
    path: '/manage-teams',
    name: 'teams',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "teamManager" */ './views/TeamsManager')
  },
  {
    path: '/addfacebook',
    name: 'addFacebook',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "sceneManager" */ './views/AddFacebook')
  },
  {
    path: '/streams',
    name: 'streams',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "streamManager" */ './views/StreamsManager')
  },
  {
    path: '/events',
    name: 'events',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "eventList" */ './views/EventList')
  },
  {
    path: '/selfServeSupport',
    name: 'selfServeSupport',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "eventList" */ './views/SelfServeSupport')
  },
  {
    path: '/mobile-not-supported',
    name: 'mobileNotSupported',
    component: () => import(/* webpackChunkName: "notAllowedMobile" */ './views/EventList')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "contactInfo" */ './views/ContactInfo')
  },
  {
    path: '/layout',
    name: 'layout',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "layoutManager" */ './views/LayoutManager')
  },
  {
    path: '/layouteditor/:id',
    name: 'layouteditor',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "layoutEditor" */ './views/LayoutEditor')
  },
  {
    path: '/widget/chat/:id',
    name: 'chatwidget',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "chatWidget" */ './views/ChatWidget')
  },
  {
    path: '/ops',
    name: 'ops',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitor" */ './views/OpsMonitor')
  },
  {
    path: '/ops/wrtcservers',
    name: 'opswrtcservers',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsWRTCServers" */ './views/WRTCOverview')
  },
  {
    path: '/ops/transcoding',
    name: 'opstranscoding',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitorTranscoding" */ './views/OpsMonitorTranscoding')
  },
  {
    path: '/ops/archiver',
    name: 'opsarchiver',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitorDetails" */ './views/OpsArchiver')
  },
  {
    path: '/ops/backendservices',
    name: 'ops_backendservices',
    meta: { requiresAuth: true},
    component: () => import('./views/OpsMonitorBackendServices')
  },
  {
    path: '/ops/srt',
    name: 'Ops SRT',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opssrt" */ './views/SRTMonitor')
  },
  {
    path: '/ops/details/:id',
    name: 'opsdetails',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "opsMonitorDetails" */ './views/OpsMonitorDetails')
  },
  {
    path: '/assets',
    name: 'assets',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "assetManager" */ './views/AssetManagement')
  },
  {
    path: '/event/edit/:id',
    name: 'editEvent',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "EventWizard" */ './views/EventWizard')
  },
  {
    path: '/event/new',
    name: 'createEvent',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "EventWizard" */ './views/EventWizard')
  },
  {
    path: '/event/:id',
    name: 'liveEvent',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "liveEvent" */ './views/LiveEvent')
  },
  {
    path: '/preview/:id',
    name: 'preview',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "preview" */ './views/Preview')
  },
  {
    path: '/cast_templates',
    name: 'castTemplates',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "castTemplates" */ './views/CastTemplates')
  },
  {
    path: '/selftest',
    name: 'selftest',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "selftest" */ './views/SelfTest')
  },
  {
    path: '/event/panel/:id/:panel',
    name: 'liveEventBreakout',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "liveEventBreakout" */ './views/LiveEventBreakout')
  },
  {
    path: '/cef/:id',
    name: 'cefEvent',
    component: () => import(/* webpackChunkName: "cefEvent" */ './views/CefEvent'),
    beforeEnter: (_to, _from, next) => next() // login via token
  },
  {
    path: '/ios-front/:id',
    name: 'iosFront',
    component: () => import(/* webpackChunkName: "cefEvent" */ './views/CefEvent'),
    // beforeEnter: (_to, _from, next) => next() // login via token
  },
  {
    path: '/ios/:id',
    name: 'iosWrapper',
    component: () => import(/* webpackChunkName: "IosWrapper" */ './views/IosWrapper'),
    // beforeEnter: (_to, _from, next) => next() // login via token
  },
  {
    path: '/reports',
    name: 'reports',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "billing" */ './views/Billing')
  },
  {
    path: '/invite/:id',
    name: 'invite',
    component: () => import(/* webpackChunkName: "inviteForm" */ './views/InviteForm')
  },
  {
    path: '/docs',
    beforeEnter: () => window.location.href = 'https://support.kiswe.com/'
  },
  {
    path: '/dev',
    name: 'dev',
    component: () => import(/* webpackChunkName: "development" */ './views/Develop')
  },
  {
    path: '/auth/action',
    name: 'auth',
    component: () => import(/* webpackChunkName: "recoverEmail" */ './views/RecoverEmail')
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "notFound" */ './views/NotFound')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

let authStateChangeUnsubscriber: firebase.Unsubscribe|null = null
/*
  Make sure that the 'next' function is called exactly once in any given pass through
  the navigation guard. It can appear more than once, but only if the logical paths
  have no overlap, otherwise the hook will never be resolved or produce errors.
*/
router.beforeEach((to, _from, next) => {
  // Unsubscribe any previous auth state change observer when moving to another
  // route. If the new route requires authentication, we'll subscribe again for
  // that route.
  if (authStateChangeUnsubscriber !== null) {
    authStateChangeUnsubscriber()
    authStateChangeUnsubscriber = null
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    authStateChangeUnsubscriber = fb.firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next()
      } else {
        next({ name: 'login', query: { redirect: to.fullPath } })
      }
    })
  } else {
    next()
  }
})

export default router
